<template>
  <v-row class="d-flex justify-center">
    <v-col cols="11">
      <v-container>
        <v-card elevation="1" id="contenedor-asignacion">
          <!-- TOOLBAR INFORMATIVO -->
          <v-row>
            <v-col cols="12">
              <v-toolbar flat elevation="4" class="mb-4">
                <v-card class="icon">
                  <v-icon
                    style="margin-left: 30px; margin-top: 25px"
                    color="white"
                    x-large=""
                    >mdi-map-marker</v-icon
                  >
                </v-card>
                <div class="usuario">Asignación de Zonas</div>
              </v-toolbar>
            </v-col>
          </v-row>
          <v-card width="100%" class="mt-5">
            <v-row>
              <!-- ASIGNAR ZONAS PARA LIDERES -->
              <v-col cols="12">
                <v-list>
                  <v-list-group
                    :value="true"
                    prepend-icon="mdi-file-excel"
                    active-class="blue--text text--darken-4"
                  >
                    <template v-slot:activator>
                      <v-list-item-title
                        >Asignar zonas para lideres
                      </v-list-item-title>
                    </template>
                    <!-- CONTENIDO -->
                    <v-container
                      fluid
                      class="grey lighten-5 grey--text text--darken-3"
                    >
                      <v-card shaped>
                        <v-card-text>
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row class="d-flex align-center">
                              <v-col cols="12" style="height: 30px">
                                <p class="text-subtitle-2">
                                  ASIGNAR ZONA A LIDER
                                </p>
                              </v-col>
                              <v-col cols="12" md="3"> Listado de zonas </v-col>
                              <v-col cols="12" md="5">
                                <v-autocomplete
                                  v-model="zonaSelect"
                                  :items="zonas"
                                  item-text="nombreZona"
                                  item-value="idZona"
                                  outlined
                                  dense
                                  chips
                                  small-chips
                                  :rules="[
                                    (v) =>
                                      !!v || 'Se requiere seleccionar una zona',
                                  ]"
                                  label="Selecciona la zona"
                                  required
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row class="d-flex align-center">
                              <v-col cols="12" md="3">
                                Listado de usuarios
                              </v-col>
                              <v-col cols="12" md="5">
                                <v-autocomplete
                                  v-model="userSelected"
                                  :items="usuarios"
                                  item-text="nombre"
                                  item-value="idUsuario"
                                  outlined
                                  dense
                                  chips
                                  small-chips
                                  :rules="[
                                    (v) =>
                                      !!v || 'Se requiere seleccionar un lider',
                                  ]"
                                  label="Selecciona un lider"
                                  required
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-btn
                              :disabled="!valid"
                              color="indigo darken-4 white--text"
                              class="mr-4"
                              @click="saveZonaLider"
                            >
                              Guardar
                            </v-btn>
                          </v-form>
                        </v-card-text>
                      </v-card>
                    </v-container>
                  </v-list-group>
                </v-list>
              </v-col>
              <!-- LISTAR ZONAS -->

              <v-col cols="12">
                <v-list>
                  <v-list-group
                    :value="false"
                    prepend-icon="mdi-clipboard-check"
                    active-class="blue--text text--darken-4"
                  >
                    <template v-slot:activator>
                      <v-list-item-title
                        >Listado de zonas asignadas a lideres
                      </v-list-item-title>
                    </template>
                    <!-- CONTENIDO -->
                    <v-container fluid class="grey lighten-5">
                      <v-data-table
                        :headers="headersZonasLideres"
                        :items="zonasLideres"
                        :items-per-page="5"
                        :search="search"
                        class="elevation-1"
                        id="table-zonas-lideres"
                      >
                        <template v-slot:top>
                          <v-text-field
                            v-model="search"
                            label="Buscar"
                            class="mx-4"
                            append-icon="mdi-magnify"
                          ></v-text-field>
                        </template>
                      </v-data-table>
                    </v-container>
                  </v-list-group>
                </v-list>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
      </v-container>
    </v-col>
    <!-- DIALOG STATUS PETICIONES -->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"> Estado del registro </v-card-title>
        <v-card-text>{{ text }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="indigo darken-1" text @click="dialog = false">
            Entendido
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- SNACKBAR STATUS PETICIONES -->
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-row>
</template>

<script>
import axios from "axios";
import env from "../env";
export default {
  data() {
    return {
      valid: true,
      zonaSelect: "",
      userSelected: "",
      zonas: [],
      usuarios: [],
      snackbar: false,
      dialog: false,
      timeout: 5000,
      text: "",
      search: "",
      headersZonasLideres: [
        {
          text: "Zona",
          align: "center",
          class: "column",
          value: "nombreZona",
        },
        {
          text: "Documento",
          value: "cedula",
          align: "center",
          class: "column",
        },
        {
          text: "Lider Vinculado",
          value: "nombre",
          align: "center",
          class: "column",
        },
      ],
      zonasLideres: [],
    };
  },
  computed: {},
  mounted() {
    this.obtenerZonas();
    this.obtenerUsuarios();
    this.obtenerZonasAsignadas();
  },
  methods: {
    saveZonaLider() {
      let validate = this.$refs.form.validate();
      if (validate) {
        const datosAsignacionZona = JSON.stringify({
          zona: this.zonaSelect,
          lider: this.userSelected,
        });
        axios
          .get(
            `${env.endpoint}user/asignarZonaLider?data=${datosAsignacionZona}`
          )
          .then((res) => {
            if (res.data == true) {
              this.text = "Asignación de zona para líder registrada con éxito.";
              this.snackbar = true;
              this.zonaSelect = "";
              this.userSelected = "";
              this.obtenerZonasAsignadas();
              this.$refs.form.reset();
            } else {
              let nombre = res.data[0].nombre;
              this.text = `El usuario ${nombre}  ya tiene asignada esta zona, por favor asignele a ${nombre} una zona temporal, en caso de querer hacer uso de la zona seleccionada previamente`;
              this.dialog = true;
            }
          })
          .catch((e) => {
            this.text =
              "Ha ocurrido un error, intente de nuevo, si el problema persiste comuníquese con el área de sistemas.";
            this.snackbar = true;
          });
      } else {
        this.snackbar = true;
        this.text = "Por favor selecciona una opción de los campos.";
      }
    },
    obtenerZonasAsignadas() {
      axios
        .get(`${env.endpoint}user/obtenerZonasLideres`)
        .then((res) => {
          this.zonasLideres = res.data;
        });
    },
    obtenerZonas() {
      axios.get(`${env.endpoint}user/consultarZonas`).then((res) => {
        this.zonas = res.data;
      });
    },
    obtenerUsuarios() {
      axios
        .get(`${env.endpoint}user/consultarLideresComerciales`)
        .then((res) => {
          this.usuarios = res.data;
        });
    },
  },
};
</script>

<style scoped>
#table-zonas-lideres {
  border: 2px solid #1d2370;
}
</style>